<template>
  <Toast />
  <div class="grid">
    <div class="col-12 md:col-12">
      <!-- TARJETA PRINCIPAL: Datos y Contraseña -->
      <div class="card">
        <h5>
          <strong>DETALLE DE USUARIO</strong>
        </h5>
        <div class="grid">
          <div class="col-5 flex align-items-center justify-content-center">
            <div class="p-fluid">
              <div class="field">
                <label for="password">Contraseña Anterior</label>
                <InputText
                  id="password"
                  v-model="user.password"
                  type="password"
                />
                <small class="p-invalid" v-if="errors.password">{{
                  errors.password[0]
                }}</small>
              </div>
              <div class="field">
                <label for="newpassword">Nueva Contraseña</label>
                <InputText
                  id="newpassword"
                  v-model="newpassword"
                  type="newpassword"
                />
                <small class="p-invalid" v-if="errors.newpassword">{{
                  errors.newpassword[0]
                }}</small>
              </div>
              <Button
                icon="pi pi-save"
                label="ACTUALIZAR CONTRASEÑA"
                @click="actualizarPassword"
              />
            </div>
          </div>
          <div class="col-2">
            <Divider layout="vertical">
              <b>PERFIL</b>
            </Divider>
          </div>
          <div class="col-5 align-items-center justify-content-center">
            <div class="field">
              <p>
                <strong>ID USUARIO:</strong> <span>{{ user.id }}</span>
              </p>
              <p>
                <strong>NOMBRE COMPLETO:</strong> <span>{{ user.name }}</span>
              </p>
            </div>
            <div class="field">
              <p>
                <strong>CORREO ELECTRÓNICO: </strong>
                <span>{{ user.email }}</span>
              </p>
            </div>
            <div class="field">
              <p>
                <strong>FECHA REGISTRO: </strong>
                <span>{{ formatFecha(user.created_at) }}</span>
              </p>
            </div>
            <div class="field">
              <p>
                <strong>FECHA ACTUALIZACIÓN: </strong>
                <span> {{ formatFecha(user.updated_at) }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- TARJETA DE SEGURIDAD 2FA -->
      <div class="card mt-4">
        <h5>Seguridad Avanzada (2FA)</h5>
        <p class="text-500 mb-3">
          Protege tu cuenta con verificación en dos pasos usando Google Authenticator.
        </p>

        <div v-if="user.google2fa_enabled" class="flex align-items-center justify-content-between">
          <div class="text-green-500 font-bold flex align-items-center">
            <i class="pi pi-check-circle mr-2 text-2xl"></i> 2FA Activado
          </div>
          <Button
            label="Desactivar"
            icon="pi pi-times"
            class="p-button-danger p-button-text"
            @click="dialogConfirmarDesactivar = true"
          />
        </div>

        <Button
          v-else
          label="Vincular Google Authenticator"
          icon="pi pi-lock"
          class="p-button-success"
          @click="iniciarActivacion2FA"
          :loading="cargando2FA"
        />
      </div>

      <!-- TARJETA DE PERMISOS -->
      <div class="card">
        <h4 class="text-center"><strong>PERMISOS ASIGNADOS</strong></h4>
        <PermissionsFrom :permisos-seleccionados="user.permissions" />
      </div>
    </div>
  </div>

  <!-- ================================================================ -->
  <!-- MODAL: Escanear QR y verificar código OTP para ACTIVAR el 2FA   -->
  <!-- ================================================================ -->
  <ZapiModalShell
    v-model:visible="dialog2FA"
    title="Configurar Google Authenticator"
    width="480px"
    confirm-label="Verificar y Activar"
    cancel-label="Cancelar"
    :loading="cargandoActivar"
    @confirm="confirmar2FA"
  >
    <div class="text-center">
      <p class="mb-2">1. Descarga <strong>Google Authenticator</strong> en tu celular.</p>
      <p class="mb-2">2. Escanea el siguiente código QR:</p>

      <!-- QR SVG generado por el backend -->
      <div
        class="my-4 flex justify-content-center"
        v-html="qrCodeSvg"
      ></div>

      <p class="mb-3">3. Ingresa el código de 6 dígitos de la aplicación:</p>

      <div class="field flex justify-content-center">
        <InputText
          v-model="codigoOTP"
          placeholder="123456"
          class="text-center text-2xl font-bold w-8"
          maxlength="6"
          @keyup.enter="codigoOTP.length === 6 && confirmar2FA()"
        />
      </div>
    </div>

    <!-- Footer personalizado: deshabilita el botón si el PIN no tiene 6 dígitos -->
    <template #footer>
      <div class="flex justify-content-end gap-2">
        <Button
          label="Cancelar"
          severity="secondary"
          text
          :disabled="cargandoActivar"
          @click="dialog2FA = false"
        />
        <Button
          label="Verificar y Activar"
          icon="pi pi-check"
          :disabled="codigoOTP.length !== 6"
          :loading="cargandoActivar"
          @click="confirmar2FA"
        />
      </div>
    </template>
  </ZapiModalShell>

  <!-- ================================================================ -->
  <!-- MODAL: Confirmación para DESACTIVAR el 2FA (sin confirm() nativo)-->
  <!-- ================================================================ -->
  <ZapiModalShell
    v-model:visible="dialogConfirmarDesactivar"
    title="Desactivar Autenticación 2FA"
    width="400px"
    confirm-label="Sí, desactivar"
    cancel-label="Cancelar"
    :loading="cargandoDesactivar"
    @confirm="desactivar2FA"
  >
    <div class="text-center py-2">
      <i class="pi pi-exclamation-triangle text-5xl text-orange-400 mb-3" style="display:block"></i>
      <p class="text-700">
        ¿Estás seguro de que deseas <strong>desactivar</strong> la autenticación de dos pasos?
      </p>
      <p class="text-500 text-sm mt-2">Tu cuenta quedará protegida solo por contraseña.</p>
    </div>
  </ZapiModalShell>
</template>

<script>
import { useAuth } from "@/stores";
import PermissionsFrom from "@/module/roles/PermissionsForm.vue";
import UserService from "@/service/UserService";
import ZapiModalShell from "@/components/shared/ZapiModalShell.vue";

export default {
  components: {
    PermissionsFrom,
    ZapiModalShell,
  },
  data() {
    return {
      user: {},
      newpassword: "",
      errors: {},
      // --- Estado 2FA ---
      dialog2FA: false,
      dialogConfirmarDesactivar: false,
      cargando2FA: false,       // Loading del botón "Vincular"
      cargandoActivar: false,   // Loading dentro del modal de activación
      cargandoDesactivar: false,
      qrCodeSvg: "",
      codigoOTP: "",
    };
  },
  userService: null,
  authService: null,
  created() {
    this.authService = useAuth();
    this.userService = new UserService();
  },
  mounted() {
    this.user = { ...this.authService.user };
    this.userService.ListarPermisosUsuarios().then((data) => {
      this.user.permissions = data.permisos;
    });
  },
  methods: {
    actualizarPassword() {
      let datos = {
        id: this.user.id,
        password: this.user.password,
        newpassword: this.newpassword,
      };
      this.userService.updatedUser(datos).then((data) => {
        if (Object.prototype.hasOwnProperty.call(data, "errors")) {
          this.errors = data.errors;
        } else {
          this.errors = {};
          if (data.status == 400) {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: data.mensaje,
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "success",
              summary: "Exito",
              detail: "Contraseña actualizada correctamente",
              life: 3000,
            });
            return this.authService.userLogout();
          }
        }
      });
    },

    formatFecha(fecha) {
      return new Date(fecha).toLocaleString();
    },

    // ----------------------------------------------------------------
    // MÉTODOS 2FA
    // ----------------------------------------------------------------

    async iniciarActivacion2FA() {
      this.cargando2FA = true;
      try {
        const response = await this.userService.generate2FA();
        if (response.success) {
          this.qrCodeSvg = response.qr_svg;
          this.codigoOTP = "";
          this.dialog2FA = true;
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "No se pudo generar el código QR.",
            life: 3000,
          });
        }
      } catch {
        this.$toast.add({
          severity: "error",
          summary: "Error de red",
          detail: "No se pudo conectar con el servidor. Intente nuevamente.",
          life: 3000,
        });
      } finally {
        this.cargando2FA = false;
      }
    },

    async confirmar2FA() {
      this.cargandoActivar = true;
      try {
        const response = await this.userService.activate2FA({ otp: this.codigoOTP });
        if (response.success) {
          this.dialog2FA = false;
          this.user.google2fa_enabled = true;
          this.$toast.add({
            severity: "success",
            summary: "¡2FA Activado!",
            detail: "Autenticación de dos pasos activada correctamente.",
            life: 4000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Código incorrecto",
            detail: response.mensaje ?? "El código ingresado no es válido.",
            life: 3000,
          });
        }
      } catch {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "No se pudo verificar el código. Intente nuevamente.",
          life: 3000,
        });
      } finally {
        this.cargandoActivar = false;
      }
    },

    async desactivar2FA() {
      this.cargandoDesactivar = true;
      try {
        const response = await this.userService.disable2FA();
        if (response.success) {
          this.dialogConfirmarDesactivar = false;
          this.user.google2fa_enabled = false;
          this.$toast.add({
            severity: "warn",
            summary: "2FA Desactivado",
            detail: "La autenticación de dos pasos ha sido removida.",
            life: 3000,
          });
        }
      } catch {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "No se pudo desactivar el 2FA. Intente nuevamente.",
          life: 3000,
        });
      } finally {
        this.cargandoDesactivar = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}
</style>